var map = {
	"./balie-1-artwork.webp": 6905,
	"./balie-1.webp": 8540,
	"./balie-2-artwork.webp": 2048,
	"./balie-2.webp": 9257,
	"./barkruk.webp": 1587,
	"./catering.webp": 9212,
	"./detailpagina-app.webp": 6116,
	"./internet.webp": 9740,
	"./licht-spots.webp": 9011,
	"./munten.webp": 6462,
	"./spots.webp": 2654,
	"./standplaats-artwork-zijkanten.webp": 8684,
	"./standplaats-standaard.webp": 6837,
	"./statafel.webp": 4129,
	"./touchscreen-55.webp": 4865,
	"./tv-scherm-43.webp": 8624,
	"./tv-scherm-55.webp": 2111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4319;